export const reviewSchema = {
  PaymentModalData:{
    heading: "Time for a quick detour.",
    body: "We're taking you to Stripe, our third-party payment provider.",
    button: "Let's go"
  },
};

export default reviewSchema;
